import React, { Component } from 'react';
import {
    CCard,
    CCardBody,
    CCardHeader,
    CCardFooter,
    CCol,
    CRow,
    CButton,
    CLabel,
    CForm,
    CFormGroup,
    CInput,
    CTextarea,
    CSelect,
    CTooltip,
    CInputRadio,
    CLink,
} from '@coreui/react';
import CIcon from '@coreui/icons-react';
import { helps } from 'src/_helpers';
import Select from 'react-select';
import Editor from 'src/_components/Editor';
import Hint from 'src/_components/Hint';
import configs from 'src/appConfigs';
import Dropzone from 'react-dropzone';

class DocForm extends Component {

    constructor(props) {
        super(props);

        this.state = {
            fields: {},
            errors: {},
            id: '',
            index: '01',
            number: '',
            title: '',
            start_date: new Date(),
            year: new Date().getFullYear(),
            category_id: '',
            default_category_id: 'D0TrbnFmeNDGXipN0enz',
            object_name: 'general',
            object_id: [],
            attachment: '',
            replace_for: [],
            create_by: this.props.user.id,
            create_date: new Date(),
            upload_files: [],
        }
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleChangeEditor = this.handleChangeEditor.bind(this);
        this.handleChangeObject = this.handleChangeObject.bind(this);
    }

    componentDidMount() {
        const doc = this.props.doc;
        //console.log(doc);
        if (!helps.isEmpty(doc) && doc.id) {
            this.setState({
                id: doc.id,
                index: doc.index ? doc.index : this.state.index,
                number: doc.number ? doc.number : this.state.number,
                title: doc.title ? doc.title : this.state.title,
                start_date: doc.start_date ? doc.start_date : this.state.start_date,
                year: doc.year ? doc.year : this.state.year,
                category_id: doc.category_id ? doc.category_id : this.state.category_id,
                replace_for: doc.replace_for ? doc.replace_for : this.state.replace_for,
                object_name: doc.object_name ? doc.object_name : this.state.object_name,
                object_id: doc.object_id ? doc.object_id : this.state.object_id,
                attachment: doc.attachment ? doc.attachment : this.state.attachment,
                create_by: doc.create_by ? doc.create_by : this.props.user.id,
                create_date: doc.create_date ? doc.create_date : new Date(),
            });
        } else {
            this.setState({
                category_id: this.state.default_category_id,
            });
            this.getNumber(this.state.default_category_id);
        }

    }

    handleSubmit(e) {
        e.preventDefault();
        if (this.handleValidation()) {
            let doc = {
                id: this.state.id,
                index: this.state.index,
                number: this.state.number,
                title: this.state.title,
                start_date: new Date(this.state.start_date),
                year: this.state.year,
                category_id: this.state.category_id,
                replace_for: this.state.replace_for,
                object_name: this.state.object_name,
                object_id: this.state.object_id,
                attachment: this.state.attachment,
                create_by: this.state.create_by,
                create_date: new Date(this.state.create_date),
            }
            this.props.handleSubmit(doc, this.state.upload_files);
        } else {
            return false;
        }
    }

    handleChange(field, e) {
        let fields = this.state.fields;
        fields[field] = e.target.value;
        this.setState({
            [field]: fields[field]
        });
        this.setState({ fields });

        if (field === 'category_id' || field === 'year') {
            this.getIndex(this.state.category_id);
        }

        if (field === 'index' || field === 'year') {
            this.getNumber(this.state.category_id);
        }

    }

    handleChangeEditor(field, value) {
        //console.log(field, value);
        this.setState({
            [field]: value
        });
    }

    handleChangeSelect(selectedOptions, field) {
        if (selectedOptions) {
            this.setState({ [field]: selectedOptions.value });
        } else {
            this.setState({ [field]: '' });
        }
        console.log(this.state);
        if (field === 'category_id') this.getNumber(selectedOptions.value);
    }

    handleChangeObject(selectedOptions) {
        if (selectedOptions) {
            this.setState({ object_id: selectedOptions });
        } else {
            this.setState({ object_id: [] });
        }
    }

    handleValidation() {
        let errors = {};
        let formIsValid = true;

        if (helps.isEmpty(this.state.category_id)) {
            errors["category_id"] = "Vui lòng chọn Nhóm Văn bản!";
        }

        if (helps.isEmpty(this.state.index)) {
            errors["index"] = "Vui lòng nhập số thứ tự Văn bản!";
        }

        if (helps.isEmpty(this.state.number)) {
            errors["number"] = "Vui lòng nhập số Văn bản!";
        }

        if (helps.isEmpty(this.state.title)) {
            formIsValid = false;
            errors["title"] = "Vui lòng nhập Tiêu đề Văn bản!";
        }

        if (helps.isEmpty(this.state.upload_files)) {
            errors["upload_files"] = "Vui lòng chọn file để tải lên!";
        }
        this.setState({ errors: errors });
        return formIsValid;
    }

    handleDrop(upload_files) {
        this.setState({ upload_files: upload_files })
    }

    getIndex(category_id) {
        const { docs } = this.props;
        let year = this.state.year;
        let _docs = docs.filter(_doc => _doc.year === year && _doc.category_id === category_id);
        let index = _docs.length + 1;
        this.setState({ index: index });
    }

    getNumber(category_id) {
        const { categories } = this.props;
        let category = helps.getItemFromArr(categories, category_id);
        let year = this.state.year;
        let index = this.state.index > 0 ? parseInt(this.state.index) : 1;
        if (index < 10) {
            index = '0' + index;
        }

        let number = index + '/' + year + '/' + category.code;
        console.log(number, category_id)
        this.setState({ number: number });
    }


    render() {
        const { categories, docs, employees, customers, housings, vendors, projects } = this.props;
        var categories_options = [];
        var default_categories_option = [];
        if (categories && categories.length > 0) {
            categories.map((category) => {
                categories_options.push({ value: category.id, label: category.name + ' - ' + category.code });
            });
            let default_category_id = !helps.isEmpty(this.state.category_id) ? this.state.category_id : this.state.default_category_id
            default_categories_option = categories_options.find(({ value }) => value === default_category_id);
        }

        var docs_options = [];
        var default_docs_options_option = [];
        if (docs && docs.length > 0) {
            docs.map((doc) => {
                docs_options.push({ value: doc.id, label: doc.title + ' (' + doc.number + ') - ' + helps.formatDate_from_Timestamp(doc.start_date) });
            });
            if (!helps.isEmpty(this.state.replace_for)) {
                default_docs_options_option = docs_options.filter(_doc => _doc.value === this.state.replace_for);
            }
        }

        let branches_options = [];
        if (!helps.isEmpty(configs.branches)) {
            Object.keys(configs.branches).map((_key) => {
                branches_options.push({ value: _key, label: configs.branches[_key] });
            })
        }

        let groups_options = [];
        if (!helps.isEmpty(configs.groups)) {
            Object.keys(configs.groups).map((_key) => {
                groups_options.push({ value: _key, label: configs.groups[_key] });
            })
        }

        let departments_options = [];
        if (!helps.isEmpty(configs.departments)) {
            Object.keys(configs.departments).map((_key) => {
                departments_options.push({ value: _key, label: configs.departments[_key] });
            })
        }

        let positions_options = [];
        if (!helps.isEmpty(configs.positions)) {
            Object.keys(configs.positions).map((_key) => {
                positions_options.push({ value: _key, label: configs.positions[_key] });
            })
        }

        let employees_options = [];
        if (!helps.isEmpty(employees)) {
            employees.map((employee) => {
                let _option = {};
                _option['value'] = employee.employee_id;
                _option['label'] = employee.fullname + ' (' + employee.employee_id + ')';
                var employee_projects = [];
                if (!helps.isEmpty(projects)) {
                    employee_projects = projects.filter((project) => {
                        if (project.employees) {
                            let found = helps.getItemFromArr(project.employees, employee.employee_id, 'employee_id');
                            if (!helps.isEmpty(found)) return true;
                            else return false;
                        } else {
                            return false;
                        }
                    })
                }
                if (!helps.isEmpty(employee_projects)) {
                    let employee_project = employee_projects[0];
                    if (!helps.isEmpty(employee_project)) {
                        _option['label'] = _option['label'] + ' - Trực tại: ' + employee_project.name;
                    }
                }
                if (employee.job_type === 'DNV') {
                    _option['label'] = _option['label'] + ' - (đã thôi việc)';
                }
                employees_options.push(_option);
            })
        }

        let customers_options = [];
        if (!helps.isEmpty(customers)) {
            customers.map((customer) => {
                customers_options.push({ value: customer.id, label: customer.name });
            })
        }

        let housings_options = [];
        if (!helps.isEmpty(housings)) {
            housings.map((housing) => {
                housings_options.push({ value: housing.id, label: housing.name + ' (' + housing.address + ')' });
            })
        }

        let vendors_options = [];
        if (!helps.isEmpty(housings)) {
            vendors.map((vendor) => {
                vendors_options.push({ value: vendor.id, label: vendor.name });
            })
        }

        let projects_options = [];
        if (!helps.isEmpty(projects)) {
            projects.map((project) => {
                projects_options.push({ value: project.id, label: project.name });
            })
        }

        let cur_year = new Date().getFullYear();

        const files = this.state.upload_files.map(file => (
            <li key={file.name}>
                {file.name} <i className='text-muted'>({helps.formatBytes(file.size, 2)})</i>
            </li>
        ));

        let input_start_date = helps.formatDate_for_input(this.state.start_date);
        return (
            <CRow>
                <CCol xl={12}>
                    <CForm onSubmit={(e) => this.handleSubmit(e)}>
                        <CCard>
                            <CCardHeader>
                                {this.props.form_header}
                            </CCardHeader>
                            <CCardBody>
                                <CRow>
                                    <CCol md={6}>
                                        <div className="mb-3">
                                            <CLabel htmlFor="input-category_id">Nhóm Văn Bản:</CLabel>
                                            <Select
                                                id="input-category_id"
                                                name="category_id"
                                                placeholder="Nhóm Văn Bản ..."
                                                isClearable
                                                options={categories_options}
                                                defaultValue={default_categories_option}
                                                onChange={(choice) => { this.handleChangeSelect(choice, 'category_id'); }}
                                            />
                                            <small className="text-danger">{this.state.errors['category_id']}</small>
                                        </div>
                                        <CRow className="mb-3">
                                            <CCol md={3}>
                                                <CLabel htmlFor="input-title">Số thứ tự:</CLabel>
                                                <CInput
                                                    type="text"
                                                    name="index"
                                                    id="input-index"
                                                    value={this.state.index}
                                                    required
                                                    className='font-weight-bold'
                                                    onChange={(e) => { this.handleChange('index', e); this.getNumber(this.state.category_id); }}
                                                    onBlur={() => { this.getNumber(this.state.category_id); }}
                                                />
                                                <small className="text-danger">{this.state.errors['index']}</small>
                                            </CCol>
                                            <CCol md={3}>
                                                <CLabel htmlFor="input-year">Năm:</CLabel>
                                                <CSelect
                                                    name="year"
                                                    id="input-year"
                                                    value={this.state.year}
                                                    onChange={(e) => { this.handleChange('year', e) }}
                                                    onBlur={() => { this.getNumber(this.state.category_id); }}
                                                >
                                                    {[...Array(3)].map((x, i) => {
                                                        let year = cur_year - i;
                                                        return (
                                                            <option key={i + 1} index={i + 1} value={year} >{year}</option>
                                                        )
                                                    })}
                                                </CSelect>
                                                <small className="text-danger">{this.state.errors['index']}</small>
                                            </CCol>
                                            <CCol md={6}>
                                                <CLabel htmlFor="input-number">Số văn bản:</CLabel>
                                                <CInput
                                                    type="text"
                                                    name="number"
                                                    id="input-number"
                                                    value={this.state.number}
                                                    className='font-weight-bold'
                                                    onChange={(e) => { this.handleChange('number', e) }}
                                                />
                                                <small className="text-danger">{this.state.errors['number']}</small>
                                            </CCol>
                                        </CRow>
                                        <div className="mb-3">
                                            <CLabel htmlFor="input-title">Tiêu đề Văn Bản:</CLabel>
                                            <CInput
                                                type="text"
                                                name="title"
                                                id="input-title"
                                                value={this.state.title}
                                                className='font-weight-bold'
                                                onChange={(e) => { this.handleChange('title', e) }}
                                            />
                                            <small className="text-danger">{this.state.errors['title']}</small>
                                        </div>
                                        <div className="mb-3">
                                            <CRow>
                                                <CCol md={6}>
                                                    <CLabel htmlFor="input-start_date">Ngày Hiệu Lực / Ban Hành:</CLabel>
                                                    <CInput
                                                        type="date"
                                                        name="start_date"
                                                        id="input-start_date"
                                                        value={input_start_date}
                                                        onChange={(e) => { this.handleChange('start_date', e) }}
                                                    />
                                                    <small className="text-danger">{this.state.errors['start_date']}</small>
                                                </CCol>
                                            </CRow>
                                        </div>
                                        <div className="mb-3">
                                            <CRow>
                                                <CCol>
                                                    <CLabel htmlFor="input-replace_for">Thay thế cho Văn bản:</CLabel>
                                                    <Select
                                                        key={this.state.replace_for}
                                                        id="input-replace_for"
                                                        name="replace_for"
                                                        placeholder="Văn bản được thay thế ..."
                                                        isClearable
                                                        options={docs_options}
                                                        defaultValue={default_docs_options_option}
                                                        onChange={(choice) => { this.handleChangeSelect(choice, 'replace_for'); }}
                                                    />
                                                    <small className="text-danger">{this.state.errors['replace_for']}</small>
                                                </CCol>
                                            </CRow>
                                        </div>
                                        <div className="mb-3">
                                            <div>
                                                <CLabel htmlFor="input-files">Đính kèm Văn bản:</CLabel>
                                            </div>
                                            {!helps.isEmpty(this.state.id) && !helps.isEmpty(this.state.attachment) && <div className='m-3'>
                                                {this.state.attachment.length > 0 && this.state.attachment.map((_file) => {
                                                    return (
                                                        <div key={this.state.id + '-' + _file.name} className="mb-1 ml-3">
                                                            <CIcon name="cil-link" className="mfe-1 mt-0"></CIcon>
                                                            <CLink href={_file.url} target='_blank'> {_file.name}</CLink>
                                                        </div>
                                                    )

                                                })}
                                                <div className="mt-3">
                                                    <CLabel htmlFor="input-files">Thay thế Đính kèm khác:</CLabel>
                                                    <small className='text-muted font-italic ml-2'>Khi tải các file đính kèm mới lên, các file đính kèm cũ sẽ bị xóa bỏ.</small>
                                                </div>
                                            </div>}
                                            <Dropzone
                                                onDrop={(files) => { this.handleDrop(files) }}
                                            >
                                                {({ getRootProps, getInputProps }) => (
                                                    <section className="container">
                                                        <div {...getRootProps({ className: 'dropzone' })}>
                                                            <input {...getInputProps()} id='input-files' />
                                                            <p>Chọn hoặc kéo thả Files tài liệu việc tại đây.</p>
                                                        </div>
                                                        <small className="text-danger">{this.state.errors['upload_files']}</small>
                                                        {!helps.isEmpty(files) && files.length > 0 && <aside>
                                                            <b>Đã chọn: </b>
                                                            <ul>{files}</ul>
                                                        </aside>}
                                                    </section>
                                                )}
                                            </Dropzone>
                                        </div>
                                    </CCol>
                                    <CCol md={6}>
                                        <div className="mb-3">
                                            <div>
                                                <CLabel>Đối tượng áp dụng:</CLabel>
                                            </div>
                                            {configs.docs_objects && Object.keys(configs.docs_objects).map((_key) => {
                                                return (
                                                    <CFormGroup variant="custom-radio" key={_key} className={'mb-2'} inline>
                                                        <CInputRadio
                                                            custom
                                                            id={"object_name_" + _key}
                                                            name="object_name"
                                                            value={_key}
                                                            checked={this.state.object_name === _key}
                                                            onChange={(e) => { this.handleChange('object_name', e); }}
                                                        />
                                                        <CLabel variant="custom-checkbox" htmlFor={"object_name_" + _key} className="cursor-pointer">
                                                            {configs.docs_objects[_key]}
                                                        </CLabel>
                                                    </CFormGroup>
                                                )
                                            }
                                            )}
                                        </div>
                                        <div className="mb-3">
                                            {this.state.object_name === 'branches' &&
                                                <div>
                                                    <CLabel htmlFor="input-branches">Chi nhánh:</CLabel>
                                                    <Select
                                                        id="input-branches"
                                                        options={branches_options}
                                                        value={this.state.object_id}
                                                        isMulti
                                                        placeholder='chọn Chi nhánh'
                                                        onChange={(choice) => { this.handleChangeObject(choice); }}
                                                    />
                                                    <small className="text-danger">{this.state.errors['object_id']}</small>
                                                </div>
                                            }
                                            {this.state.object_name === 'groups' &&
                                                <div>
                                                    <CLabel htmlFor="input-groups">Khối:</CLabel>
                                                    <Select
                                                        id="input-groups"
                                                        options={groups_options}
                                                        value={this.state.object_id}
                                                        isMulti
                                                        placeholder='chọn Khối'
                                                        onChange={(choice) => { this.handleChangeObject(choice); }}
                                                    />
                                                    <small className="text-danger">{this.state.errors['object_id']}</small>
                                                </div>
                                            }
                                            {this.state.object_name === 'departments' &&
                                                <div>
                                                    <CLabel htmlFor="input-departments">Bộ phận/Phòng ban:</CLabel>
                                                    <Select
                                                        id="input-departments"
                                                        options={departments_options}
                                                        value={this.state.object_id}
                                                        isMulti
                                                        placeholder='chọn Bộ phận/Phòng ban'
                                                        onChange={(choice) => { this.handleChangeObject(choice); }}
                                                    />
                                                    <small className="text-danger">{this.state.errors['object_id']}</small>
                                                </div>
                                            }
                                            {this.state.object_name === 'positions' &&
                                                <div>
                                                    <CLabel htmlFor="input-positions">Vị trí/Chức vụ:</CLabel>
                                                    <Select
                                                        id="input-positions"
                                                        options={positions_options}
                                                        value={this.state.object_id}
                                                        isMulti
                                                        placeholder='chọn Vị trí/Chức vụ'
                                                        onChange={(choice) => { this.handleChangeObject(choice); }}
                                                    />
                                                    <small className="text-danger">{this.state.errors['object_id']}</small>
                                                </div>
                                            }
                                            {this.state.object_name === 'employees' &&
                                                <div>
                                                    <CLabel htmlFor="input-employees">Nhân Sự:</CLabel>
                                                    <Select
                                                        id="input-employees"
                                                        options={employees_options}
                                                        value={this.state.object_id}
                                                        isMulti
                                                        placeholder='chọn Nhân viên'
                                                        onChange={(choice) => { this.handleChangeObject(choice); }}
                                                    />
                                                    <small className="text-danger">{this.state.errors['object_id']}</small>
                                                </div>
                                            }
                                            {this.state.object_name === 'customers' &&
                                                <div>
                                                    <CLabel htmlFor="input-customers">Khách Hàng:</CLabel>
                                                    <Select
                                                        id="input-customers"
                                                        options={customers_options}
                                                        value={this.state.object_id}
                                                        isMulti
                                                        placeholder='chọn Khách hàng'
                                                        onChange={(choice) => { this.handleChangeObject(choice); }}
                                                    />
                                                    <small className="text-danger">{this.state.errors['object_id']}</small>
                                                </div>
                                            }

                                            {this.state.object_name === 'housings' &&
                                                <div>
                                                    <CLabel htmlFor="input-housings">Nhà Đội:</CLabel>
                                                    <Select
                                                        id="input-housings"
                                                        options={housings_options}
                                                        value={this.state.book_object_ids}
                                                        isMulti
                                                        placeholder='chọn Nhà đội'
                                                        onChange={(choice) => { this.handleChangeObject(choice); }}
                                                    />
                                                    <small className="text-danger">{this.state.errors['object_id']}</small>
                                                </div>
                                            }

                                            {this.state.object_name === 'projects' &&
                                                <div>
                                                    <CLabel htmlFor="input-projects">Mục Tiêu:</CLabel>
                                                    <Select
                                                        id="input-projects"
                                                        options={projects_options}
                                                        value={this.state.object_id}
                                                        isMulti
                                                        placeholder='chọn Mục tiêu'
                                                        onChange={(choice) => { this.handleChangeObject(choice); }}
                                                    />
                                                    <small className="text-danger">{this.state.errors['object_id']}</small>
                                                </div>
                                            }

                                            {this.state.object_name === 'vendors' &&
                                                <div className="mb-3">
                                                    <CLabel htmlFor="input-vendors">Nhà Cung Cấp:</CLabel>
                                                    <Select
                                                        id="input-vendors"
                                                        options={vendors_options}
                                                        value={this.state.book_object_ids}
                                                        isMulti
                                                        placeholder='chọn Nhà cung cấp'
                                                        onChange={(choice) => { this.handleChangeObject(choice); }}
                                                    />
                                                    <small className="text-danger">{this.state.errors['object_id']}</small>
                                                </div>
                                            }

                                            {this.state.object_name === 'other' &&
                                                <div>
                                                    <CLabel htmlFor="input-other">Đối tượng khác:</CLabel>
                                                    <CTextarea
                                                        name="note"
                                                        id="input-other"
                                                        value={this.state.book_object_content}
                                                        onChange={(e) => { this.handleChange('object_id', e) }}
                                                    />
                                                    <small className="text-danger">{this.state.errors['object_id']}</small>
                                                </div>
                                            }
                                        </div>
                                        <div className="mb-3">
                                            <CLabel htmlFor="input-address">Nội dung<i className='text-muted'>(optional)</i>:</CLabel>
                                            <Editor
                                                {... this.props}
                                                id="input-content"
                                                name="content"
                                                defaultValue={this.state.content}
                                                handleChangeEditor={this.handleChangeEditor}
                                            />
                                            <small className="text-danger">{this.state.errors['content']}</small>
                                        </div>
                                    </CCol>
                                </CRow>
                            </CCardBody>
                            <CCardFooter>
                                <CTooltip content={'Lưu'}>
                                    <CButton type="submit" color="primary">
                                        <CIcon name="cil-save" className="mfe-1 mt-0"></CIcon>
                                        Lưu
                                    </CButton>
                                </CTooltip>
                            </CCardFooter>
                        </CCard>
                    </CForm>
                </CCol>
            </CRow >
        )
    }
}
export default DocForm;

